// extracted by mini-css-extract-plugin
export default {"countdown":"Index_countdown__XQHU-","item":"Index_item__IW5qp","value":"Index_value__+Pscq","title":"Index_title__st-B4","form":"Index_form__iHJKN"};